import { useParams } from "react-router-dom";
import DocumentViewer from "../../../../components/DocumentViewer/DocumentViewer";
import { useFetchDocuments } from "../../hooks/clients.queries";

export default function ClientDocument() {
    const params = useParams();
    const clientId = params.clientId as string;
    const documentId = params.documentId as string;

    const { data } = useFetchDocuments({
        client_id: clientId,
        document_id: documentId,
    });

    const documentInViewDetails = data?.data[0];

    return (
        <div className="page">
            {documentInViewDetails?.metadata?.content_type &&
            /^image/.test(documentInViewDetails?.metadata?.content_type) ? (
                <p className="font-medium !text-title text-center capitalize underline mb-12">
                    {documentInViewDetails?.title}
                </p>
            ) : null}

            <DocumentViewer
                document={documentInViewDetails}
                file={documentInViewDetails?.url}
            />
        </div>
    );
}
